import React, { useEffect, useState, useRef } from "react";
import { MenuItem, TextField, Grid, Button } from '@mui/material';
import { useAuth } from '../../services/AuthContext.js';
import "./comments.css";
import { all } from "axios";

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

const ProfileImage = ({ src, alt }) => {
  const default_profile_image_url = "https://dominio-eletrico-profile-images-dev.s3.us-east-1.amazonaws.com/default_user_image.jpg";
  const [imgSrc, setImgSrc] = useState(src || default_profile_image_url);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className="comment-avatar"
      onError={() => setImgSrc(default_profile_image_url)}
    />
  );
};

const Comments = ({ courseId, sectionId, lessonId }) => {
  const { user, loading, getIdToken } = useAuth(); 
  const [name, setName] = useState('');
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [comment, setComment] = useState('');
  const [allComments, setAllComments] = useState([]);
  const [errors, setErrors] = useState('');
  const [responseMessage, setResponseMessage] = useState('');

  const formatDate = (utcString) => {
    const date = new Date(utcString);
    return new Intl.DateTimeFormat(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }).format(date);
  };

  const loadComments = async () => {
    try {
      setCommentsLoading(true);
      setErrors(null);
      const token = await getIdToken();
      const response = await fetch(`${baseAPI_URL}/comments/${courseId}/${sectionId}/${lessonId}`, {
        headers: {
          Authorization: `Bearer: ${token}`
        }
      });
      const data = await response.json();
      setAllComments(data);
    } catch (err) {
      console.error("Error loading comments: ", err);
      setErrors("Não foi possível carregar os comentários.");
    } finally {
      setCommentsLoading(false);
    }
  };

  const submitComment = async () => {
    try {
      setErrors(null);
      const token = await getIdToken();
      const payload = {
        course_slug: courseId,
        section_slug: sectionId,
        lesson_slug: lessonId,
        content: comment
      };
      const response = await fetch(`${baseAPI_URL}/comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      setComment("");
      loadComments();
    } catch (err) {
      console.error("Error submitting comment: ", err);
      setErrors("Não foi possível enviar comentário.");
    }
  }

  useEffect(() => {
    loadComments();
  }, [courseId, sectionId, lessonId]);

  const MAX_COMMENT_LENGTH = 500;

  return (
      <div className="form">
        <h2>Comentários da aula ({allComments.length})</h2>

        <div className="comments-list" role="menu">
        {allComments.map((item, index) => (
            <div key={index} className="comment-item">
            <div className="comment-header">
              <div className="comment-user">
                <ProfileImage
                  src={item.profile_photo}
                  alt={item.full_name}
                />
                <a href={`/user/${item.slug}`} target="_blank">
                  <span className="comment-author">{item.full_name}</span>
                </a>
              </div>
              <span className="comment-date">
                {formatDate(item.created_at)}
              </span>
            </div>
            <div className="comment-message">{item.content}</div>
            </div>
        ))}
        </div>

        <p>
          Deixe um comentário com a sua dúvida ou compartilhe o seu conhecimento sobre o assunto conosco.
        </p>

        <div className="formfield">
          <TextField
            label="Comentário"
            variant="outlined"
            fullWidth
            required
            multiline
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            inputProps={{ 
                maxLength: MAX_COMMENT_LENGTH
            }}
            helperText={`${comment.length}/${MAX_COMMENT_LENGTH}`}
            FormHelperTextProps={{
                style: { textAlign: 'right' }
            }}
          />
        </div>

        {errors && <p className="errormsg">{errors}</p>}

        {responseMessage && <p className="successmsg">{responseMessage}</p>}

        <div className="comments-footer">
          <Button
            className="lesson-comment-send-btn"
            onClick={submitComment}
            variant="contained"
            disabled={!comment.trim()}
          >
            Enviar comentário
          </Button>
        </div>

      </div>
  );
};

export default Comments;
